export enum DocumentReviewerStep {
    ContractSelection = 1,
    DocTypeSelection = 2,
    MergeConflict = 3,
    ReadonlyView = 4
}
